export const environment = {
  production: true,
  hmr: false,
  serverUrl: 'https://api.gamble.social/api/v1/',
  serverUrl2: 'http://localhost:8080/api/v1/',
  socketUrl: 'https://api.gamble.social/',
  socketUrl2: 'http://localhost:8080/',
  imgUrl: 'root/storage/uploads',
};
